export default "__VITE_ASSET__DMP72K_B__"